import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '../components/SvgIcon/SvgIcon';

export function ArrowRightLongIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <g id="trending_flat_right">
                <path
                    id="vector"
                    d="M17.5 16.5L16.075 15.1L18.175 13L3 13L3 11L18.175 11L16.1 8.9L17.525 7.5L22 12L17.5 16.5Z"
                />
            </g>
        </SvgIcon>
    );
}
